import ContactPageBanner from "@/components/ContactPage/ContactPageBanner";
import SubmitForm from "@/components/Shared/SubmitForm";
import SEO from "@/components/SEO";
import vector from "@/assets/contact/vector-contact-bottom.png";
import localizePath from "@/functions/localizePath";

export default function ContactPage({ locale = "en" }) {
  return (
    <>
      <SEO
        path={localizePath("/contact", locale)}
        title="Contact Us | Lawrence Harvey"
        description="Reach out to one of our local offices."
      />
      <main className="bg-purple h-full relative">
        <ContactPageBanner />
        <div className="pt-24 contact_form">
          <SubmitForm />
        </div>
        <img
          src={vector ?? ""}
          alt="vector"
          className="absolute bottom-[-100px]"
        />
      </main>
    </>
  );
}
